<template>
  <div class="retrospective">
    <BackButton class="back-btn--retrospective" />
    <div v-if="!form">
      <Spinner />
    </div>
    <div v-else class="retrospective__content">
      <div>
        <div v-if="computedForm.hire_request">
          <div class="page-title">
            Retrospective for<br />
            Hire Request #{{ computedForm.hire_request.value }}
          </div>
        </div>
        <div v-else-if="computedForm.gigs">
          <div class="page-title">
            {{ `Retrospective for ${computedForm.gigs.value}` }}
          </div>
        </div>
      </div>

      <div class="retrospective__fields">
        <div class="retrospective__topmatter">
          <div class="retrospective__form-row" v-if="computedForm.hire_request">
            <div class="retrospective__form-row__label">
              <div>Project code(s):</div>
            </div>
            <div class="retrospective__form-row__value">
              {{ computedForm.gigs.value }}
            </div>
          </div>
          <div class="retrospective__form-row" v-if="computedForm.gigs">
            <div class="retrospective__form-row__label"><div>Creator</div></div>
            <div class="retrospective__form-row__value">
              <TableRowAvatar
                :user="form.creator"
                :path="`/p/${form.creator.username || form.creator.id}`"
              />
            </div>
          </div>
        </div>
        <div class="retrospective__body">
          <div
            v-for="field in visibleFields"
            :key="field.uuid"
            class="retrospective__form-row"
          >
            <div class="retrospective__form-row__label">{{ field.label }}</div>
            <div class="retrospective__form-row__value">{{ field.value }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TableRowAvatar from "@/components/work-assignments/TableRowAvatar.vue";
export default {
  head: {
    title: "Retrospective",
    titleTemplate: "%s | iU Community",
  },
  components: { TableRowAvatar },
  data() {
    return {
      loading: true,
      form: null,
    };
  },
  mounted() {
    if (this.$route.params.id) {
      this.fetchRetrospective();
    }
  },
  methods: {
    async fetchRetrospective() {
      try {
        const response = await this.$api.Retrospective.get({
          monday_com_item_id: this.$route.params.id,
        });
        this.form = response.data;
      } catch (e) {
        this.$alert("Something went wrong", "error");
      }
    },
  },
  computed: {
    computedForm() {
      if (!this.form) return null;
      const result = {};
      this.form.formatted_data.forEach((field) => {
        result[field.short_name] = field;
      });
      return result;
    },
    visibleFields() {
      if (!this.form) return null;
      return this.form.formatted_data.filter(
        (field) => field.type != "HiddenField"
      );
    },
  },
};
</script>

<style scoped lang="scss">
.retrospective {
  display: flex;
  flex-direction: column;
  align-items: center;
  .back-btn--retrospective {
    align-self: flex-start;
  }
  &__content {
    width: 600px;
    max-width: 100%;
  }
  &__topmatter {
    display: grid;
    grid-template-columns: 150px auto;
  }
  &__topmatter &__form-row {
    &__label {
      display: flex;
      align-items: center;
    }
  }
  &__form-row {
    padding: 10px 0;
    display: grid;
    grid-template-columns: subgrid;
    grid-column: 1 / span 2;

    &__label {
      color: #56565a;
      font-weight: bold;
      line-height: 1.2;
      padding-right: 20px;
    }
    &__value {
      display: flex;
    }
    &__label,
    &__value {
      @media screen and (max-width: 600px) {
        grid-column: 1 / span 2;
      }
    }
  }
}
</style>
